import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IMAGE_CONFIG } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular/lazy';
import { AppComponent } from 'src/app/app.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { DatabaseService } from 'src/app/services/database.service';
import { StorageService } from 'src/app/services/storage.service';
import { ObserverService } from 'src/app/services/observer.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { ProductService } from 'src/app/services/product.service';
import { PersonService } from 'src/app/services/person.service';
import { EventService } from 'src/app/services/event.service';
import { RegisterService } from 'src/app/services/register.service';
import { UserService } from 'src/app/services/user.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { TaxZoneService } from 'src/app/services/tax-zone.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { GlobalVariableService } from 'src/app/services/globalvariable.service';
import { APIService } from 'src/app/services/api.service';
import { PusherService } from 'src/app/services/pusher.service';
import { PendingOrderService } from 'src/app/services/pending-order.service';
import { CountryService } from 'src/app/services/country.service';
import { CourierService } from 'src/app/services/courier.service';
import { DonationCampaignService } from 'src/app/services/donation-campaign.service';
import { GiftVoucherService } from 'src/app/services/gift-voucher.service';
import { CashTrackingService } from 'src/app/services/cash-tracking.service';
import { ParkedCartService} from 'src/app/services/parked-cart.service';
import { ParkedCartLegacyService} from 'src/app/services/parked-cart-legacy.service';
import { QuoteService} from 'src/app/services/quote.service';
import { OrderService } from 'src/app/services/order.service';
import { CustomPaymentServiceService } from 'src/app/services/custom-payment-service.service';
import { DesktopPrintClientService } from 'src/app/services/desktop-print-client.service';
import { CashDrawerService } from 'src/app/services/cash-drawer.service';
import { ReceiptPrinterService } from 'src/app/services/receipt-printer.service';
import { MeasurementUnitService } from 'src/app/services/measurement-unit.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HttpErrorInterceptor } from 'src/app/interceptors/http-error.interceptor';
import { FormsModule } from '@angular/forms';
import { Printer } from 'capacitor-printer';
import { RouterExtService } from 'src/app/services/routerext.service';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { UserPINVerifyPageModule } from 'src/app/modals/user-pin-verify/user-pin-verify.module';
import { UserPINChangePageModule } from 'src/app/modals/user-pin-change/user-pin-change.module';
import { CartAdditionalInfoPageModule } from 'src/app/modals/cart-additional-info/cart-additional-info.module';
import { CartPickupPageModule } from 'src/app/modals/cart-pickup/cart-pickup.module';
import { CartShippingPageModule } from 'src/app/modals/cart-shipping/cart-shipping.module';
import { CartCustomerPageModule } from 'src/app/modals/cart-customer/cart-customer.module';
import { CartOptionsComponent } from 'src/app/popovers/cart-options/cart-options.component';
import { CartPricingTierPageModule } from 'src/app/modals/cart-pricing-tier/cart-pricing-tier.module';
import { CartCurrencyPageModule } from 'src/app/modals/cart-currency/cart-currency.module';
import { CartParkPageModule} from 'src/app/modals/cart-park/cart-park.module';
import { CartDiscountPageModule} from 'src/app/modals/cart-discount/cart-discount.module';
import { CartEditItemPageModule } from 'src/app/modals/cart-edit-item/cart-edit-item.module';
import { AddressBookShippingAddressOptionsComponent } from 'src/app/popovers/address-book-shipping-address-options/address-book-shipping-address-options.component';
import { OrderOptionsComponent } from 'src/app/popovers/order-options/order-options.component';
import { OrderPaymentOptionsComponent } from 'src/app/popovers/order-payment-options/order-payment-options.component';
import { OrderRefundOptionsComponent } from 'src/app/popovers/order-refund-options/order-refund-options.component';
import { OrderRefundPaymentOptionsComponent } from 'src/app/popovers/order-refund-payment-options/order-refund-payment-options.component';
import { OrderReturnOptionsComponent } from 'src/app/popovers/order-return-options/order-return-options.component';
import { OrderFulfillmentOptionsComponent } from 'src/app/popovers/order-fulfillment-options/order-fulfillment-options.component';
import { OrderConfirmationPrintOptionsComponent } from 'src/app/popovers/order-confirmation-print-options/order-confirmation-print-options.component';
import { OrdersQuickSearchComponent } from 'src/app/popovers/orders-quick-search/orders-quick-search.component';
import { PersonOptionsComponent } from 'src/app/popovers/person-options/person-options.component';
import { PersonShippingAddressOptionsComponent } from 'src/app/popovers/person-shipping-address-options/person-shipping-address-options.component';
import { ParkedCartOptionsComponent } from 'src/app/popovers/parked-cart-options/parked-cart-options.component';
import { OrganisationOptionsComponent } from 'src/app/popovers/organisation-options/organisation-options.component';
import { OrganisationShippingAddressOptionsComponent } from 'src/app/popovers/organisation-shipping-address-options/organisation-shipping-address-options.component';
import { QuoteOptionsComponent } from 'src/app/popovers/quote-options/quote-options.component';
import { PersonEditPageModule } from 'src/app/modals/person-edit/person-edit.module';
import { PersonShippingAddressAddPageModule } from 'src/app/modals/person-shipping-address-add/person-shipping-address-add.module';
import { PersonShippingAddressEditPageModule } from 'src/app/modals/person-shipping-address-edit/person-shipping-address-edit.module';
import { PersonAddPageModule } from 'src/app/modals/person-add/person-add.module';
import { PersonAddCommentPageModule } from 'src/app/modals/person-add-comment/person-add-comment.module';
import { PersonFilterPageModule } from 'src/app/modals/person-filter/person-filter.module'
import { PersonAddStoreCreditPageModule } from 'src/app/modals/person-add-store-credit/person-add-store-credit.module';
import { PersonRemoveStoreCreditPageModule } from 'src/app/modals/person-remove-store-credit/person-remove-store-credit.module';
import { SelectProductVariantPageModule } from 'src/app/modals/select-product-variant/select-product-variant.module';
import { CheckoutPaymentExternalCardPageModule } from 'src/app/modals/checkout-payment-external-card/checkout-payment-external-card.module';
import { CheckoutPaymentCashPageModule } from 'src/app/modals/checkout-payment-cash/checkout-payment-cash.module';
import { CheckoutPaymentChequePageModule } from 'src/app/modals/checkout-payment-cheque/checkout-payment-cheque.module';
import { CheckoutPaymentGiftVoucherPageModule } from 'src/app/modals/checkout-payment-gift-voucher/checkout-payment-gift-voucher.module';
import { CheckoutPaymentStoreCreditPageModule } from 'src/app/modals/checkout-payment-store-credit/checkout-payment-store-credit.module';
import { CheckoutPaymentOnAccountPageModule } from 'src/app/modals/checkout-payment-on-account/checkout-payment-on-account.module';
import { CheckoutPaymentBankTransferPageModule } from 'src/app/modals/checkout-payment-bank-transfer/checkout-payment-bank-transfer.module';
import { CheckoutPaymentStripeTerminalPageModule } from 'src/app/modals/checkout-payment-stripe-terminal/checkout-payment-stripe-terminal.module';
import { CheckoutPaymentCustomPaymentServicePageModule } from 'src/app/modals/checkout-payment-custom-payment-service/checkout-payment-custom-payment-service.module';
import { SelectEventTicketTypePageModule } from 'src/app/modals/select-event-ticket-type/select-event-ticket-type.module';
import { SelectEventSessionPageModule } from 'src/app/modals/select-event-session/select-event-session.module';
import { SelectEventSessionTicketTypePageModule } from 'src/app/modals/select-event-session-ticket-type/select-event-session-ticket-type.module';
import { SettingsStarMicronicsReceiptPrinterPageModule } from 'src/app/modals/settings-star-micronics-receipt-printer/settings-star-micronics-receipt-printer.module';
import { SettingsChangeRegisterPageModule } from 'src/app/modals/settings-change-register/settings-change-register.module';
import { SettingsChangeSmartpayReaderPageModule } from 'src/app/modals/settings-change-smartpay-reader/settings-change-smartpay-reader.module';
import { SettingsChangeStripeTerminalReaderPageModule } from 'src/app/modals/settings-change-stripe-terminal-reader/settings-change-stripe-terminal-reader.module';
import { SellDonationPageModule } from 'src/app/modals/sell-donation/sell-donation.module';
import { SellGiftVoucherPageModule } from 'src/app/modals/sell-gift-voucher/sell-gift-voucher.module';
import { SettingsChangePrinterPaperSizesPageModule } from 'src/app/modals/settings-change-printer-paper-sizes/settings-change-printer-paper-sizes.module';
import { CashTrackingStartTrackingPageModule} from 'src/app/modals/cash-tracking-start-tracking/cash-tracking-start-tracking.module';
import { CashTrackingEndTrackingPageModule} from 'src/app/modals/cash-tracking-end-tracking/cash-tracking-end-tracking.module';
import { CashTrackingAddCashPageModule} from 'src/app/modals/cash-tracking-add-cash/cash-tracking-add-cash.module';
import { CashTrackingRemoveCashPageModule} from 'src/app/modals/cash-tracking-remove-cash/cash-tracking-remove-cash.module';
import { CashTrackingCashMovementsPageModule } from 'src/app/modals/cash-tracking-cash-movements/cash-tracking-cash-movements.module';
import { ParkedCartEditPageModule } from 'src/app/modals/parked-cart-edit/parked-cart-edit.module';
import { ParkedCartFilterPageModule } from 'src/app/modals/parked-cart-filter/parked-cart-filter.module'
import { ReportsPendingOrdersPageModule } from 'src/app/modals/reports-pending-orders/reports-pending-orders.module';
import { OrderFilterPageModule } from 'src/app/modals/order-filter/order-filter.module'
import { OrderEmailInvoicePageModule } from 'src/app/modals/order-email-invoice/order-email-invoice.module'
import { OrderAddCommentPageModule } from 'src/app/modals/order-add-comment/order-add-comment.module'
import { OrderEditPageModule } from 'src/app/modals/order-edit/order-edit.module'
import { OrderItemEditPageModule } from 'src/app/modals/order-item-edit/order-item-edit.module'
import { PersonPickerPageModule } from 'src/app/modals/person-picker/person-picker.module';
import { OrganisationPickerPageModule } from 'src/app/modals/organisation-picker/organisation-picker.module';
import { OrganisationAddPageModule } from 'src/app/modals/organisation-add/organisation-add.module';
import { OrganisationEditPageModule } from 'src/app/modals/organisation-edit/organisation-edit.module';
import { OrganisationShippingAddressAddPageModule } from 'src/app/modals/organisation-shipping-address-add/organisation-shipping-address-add.module';
import { OrganisationShippingAddressEditPageModule } from 'src/app/modals/organisation-shipping-address-edit/organisation-shipping-address-edit.module';
import { OrganisationAddCommentPageModule } from 'src/app/modals/organisation-add-comment/organisation-add-comment.module';
import { OrganisationFilterPageModule } from 'src/app/modals/organisation-filter/organisation-filter.module'
import { OrganisationAddStoreCreditPageModule } from 'src/app/modals/organisation-add-store-credit/organisation-add-store-credit.module';
import { OrganisationRemoveStoreCreditPageModule } from 'src/app/modals/organisation-remove-store-credit/organisation-remove-store-credit.module';
import { CountryPickerPageModule } from 'src/app/modals/country-picker/country-picker.module';
import { AffiliatePickerPageModule } from 'src/app/modals/affiliate-picker/affiliate-picker.module';
import { AddressFinderPageModule } from 'src/app/modals/address-finder/address-finder.module';
import { AddressPickerPageModule } from 'src/app/modals/address-picker/address-picker.module';
import { DateTimePickerPageModule } from 'src/app/modals/date-time-picker/date-time-picker.module';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";
import { OrderPaymentAddPageModule } from 'src/app/modals/order-payment-add/order-payment-add.module';
import { OrderPaymentEditPageModule } from 'src/app/modals/order-payment-edit/order-payment-edit.module';
import { OrderRefundAddPageModule } from 'src/app/modals/order-refund-add/order-refund-add.module';
import { OrderRefundEditPageModule } from 'src/app/modals/order-refund-edit/order-refund-edit.module';
import { OrderRefundPaymentAddPageModule } from 'src/app/modals/order-refund-payment-add/order-refund-payment-add.module';
import { OrderRefundPaymentEditPageModule } from 'src/app/modals/order-refund-payment-edit/order-refund-payment-edit.module';
import { OrderReturnAddPageModule } from 'src/app/modals/order-return-add/order-return-add.module';
import { OrderReturnEditPageModule } from 'src/app/modals/order-return-edit/order-return-edit.module';
import { OrderFulfillmentEditPageModule } from 'src/app/modals/order-fulfillment-edit/order-fulfillment-edit.module';
import { OrderFulfillmentAddPageModule } from 'src/app/modals/order-fulfillment-add/order-fulfillment-add.module';
import { StripeTerminalReaderService } from 'src/app/services/stripe-terminal-reader.service';
import { ReportsPaymentsAndRefundsFilterPageModule } from 'src/app/modals/reports-payments-and-refunds-filter/reports-payments-and-refunds-filter.module';
import { CheckoutPaymentSmartpayCardPageModule } from 'src/app/modals/checkout-payment-smartpay/checkout-payment-smartpay.module';
import { ShippingAddressAddPageModule } from 'src/app/modals/shipping-address-add/shipping-address-add.module';
import { CartQuotePageModule } from 'src/app/modals/cart-quote/cart-quote.module';
import { QuoteEditPageModule } from 'src/app/modals/quote-edit/quote-edit.module';
import { QuoteFilterPageModule } from 'src/app/modals/quote-filter/quote-filter.module';
import { QuoteMarkAsSentPageModule } from 'src/app/modals/quote-mark-as-sent/quote-mark-as-sent.module';
import { QuoteMarkAsDeclinedPageModule } from 'src/app/modals/quote-mark-as-declined/quote-mark-as-declined.module';
import { QuoteMarkAsAcceptedPageModule } from 'src/app/modals/quote-mark-as-accepted/quote-mark-as-accepted.module';
import { QuoteCancelPageModule } from 'src/app/modals/quote-cancel/quote-cancel.module';
import { QuoteEmailPageModule } from 'src/app/modals/quote-email/quote-email.module';

// Sentry's integrations (PerformanceObservers etc.) still get set up even with
// `enabled: false`, which caused a "Cannot read properties of undefined (reading
// 'startTime')" crash during dev-mode (ionic serve) navigation. Skip initializing
// Sentry entirely outside production instead of just disabling event capture -
// captureException/captureMessage/setContext are safe no-ops without an initialized
// client, so nothing else in the app needs to change.
if (process.env.NODE_ENV === 'production') {
    Sentry.init(
        {
            dsn: 'https://b7dd747783c74d2f9633a92f7c9ccb6a@o292210.ingest.sentry.io/5544150',
            release: 'pos@321',
            enabled: true,
            // Defensive: we don't use performance tracing or web vitals reporting.
            integrations: (integrations) => integrations.filter((integration) => integration.name !== 'BrowserTracing' && integration.name !== 'WebVitals')
        },
        SentryAngular.init
    );
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    handleError(error: any): void {

        const chunkFailedMessage = /Loading chunk [^\s]+ failed/;
        
        if(chunkFailedMessage.test(error.message)) {
            window.location.reload();
        }

        console.error(error);

    }

}

@NgModule({ declarations: [
        AppComponent,
        AddressBookShippingAddressOptionsComponent,
        CartOptionsComponent,
        OrderOptionsComponent,
        OrderPaymentOptionsComponent,
        OrderRefundOptionsComponent,
        OrderRefundPaymentOptionsComponent,
        OrderReturnOptionsComponent,
        OrderFulfillmentOptionsComponent,
        OrderConfirmationPrintOptionsComponent,
        OrdersQuickSearchComponent,
        PersonOptionsComponent,
        PersonShippingAddressOptionsComponent,
        ParkedCartOptionsComponent,
        OrganisationOptionsComponent,
        OrganisationShippingAddressOptionsComponent,
        QuoteOptionsComponent,
    ],
    bootstrap: [AppComponent], imports: [IonicModule.forRoot({
            innerHTMLTemplatesEnabled: true
        }),
        FontAwesomeModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        UserPINVerifyPageModule,
        UserPINChangePageModule,
        CartAdditionalInfoPageModule,
        CartDiscountPageModule,
        CartPickupPageModule,
        CartShippingPageModule,
        CartCustomerPageModule,
        CartEditItemPageModule,
        CartPricingTierPageModule,
        CartCurrencyPageModule,
        CartParkPageModule,
        SettingsChangeRegisterPageModule,
        SettingsChangeSmartpayReaderPageModule,
        SettingsChangeStripeTerminalReaderPageModule,
        SettingsChangeSmartpayReaderPageModule,
        PersonEditPageModule,
        PersonShippingAddressAddPageModule,
        PersonShippingAddressEditPageModule,
        PersonAddPageModule,
        PersonAddCommentPageModule,
        PersonAddStoreCreditPageModule,
        PersonRemoveStoreCreditPageModule,
        SelectProductVariantPageModule,
        CheckoutPaymentExternalCardPageModule,
        CheckoutPaymentCashPageModule,
        CheckoutPaymentChequePageModule,
        CheckoutPaymentGiftVoucherPageModule,
        CheckoutPaymentStoreCreditPageModule,
        CheckoutPaymentOnAccountPageModule,
        CheckoutPaymentBankTransferPageModule,
        CheckoutPaymentStripeTerminalPageModule,
        CheckoutPaymentSmartpayCardPageModule,
        CheckoutPaymentCustomPaymentServicePageModule,
        SelectEventTicketTypePageModule,
        SelectEventSessionPageModule,
        SelectEventSessionTicketTypePageModule,
        SettingsStarMicronicsReceiptPrinterPageModule,
        SellDonationPageModule,
        SellGiftVoucherPageModule,
        SettingsChangePrinterPaperSizesPageModule,
        ReportsPaymentsAndRefundsFilterPageModule,
        ReportsPendingOrdersPageModule,
        CashTrackingStartTrackingPageModule,
        CashTrackingEndTrackingPageModule,
        CashTrackingAddCashPageModule,
        CashTrackingRemoveCashPageModule,
        CashTrackingCashMovementsPageModule,
        ParkedCartEditPageModule,
        ParkedCartFilterPageModule,
        OrderFilterPageModule,
        OrderEmailInvoicePageModule,
        OrderAddCommentPageModule,
        OrderPaymentAddPageModule,
        OrderPaymentEditPageModule,
        OrderRefundAddPageModule,
        OrderRefundEditPageModule,
        OrderRefundPaymentAddPageModule,
        OrderRefundPaymentEditPageModule,
        OrderReturnAddPageModule,
        OrderReturnEditPageModule,
        OrderFulfillmentEditPageModule,
        OrderFulfillmentAddPageModule,
        OrderEditPageModule,
        OrderItemEditPageModule,
        PersonPickerPageModule,
        PersonFilterPageModule,
        OrganisationPickerPageModule,
        OrganisationFilterPageModule,
        OrganisationAddStoreCreditPageModule,
        OrganisationRemoveStoreCreditPageModule,
        VirtualScrollerModule,
        OrganisationAddPageModule,
        OrganisationEditPageModule,
        OrganisationShippingAddressAddPageModule,
        OrganisationShippingAddressEditPageModule,
        OrganisationAddCommentPageModule,
        CountryPickerPageModule,
        AffiliatePickerPageModule,
        AddressFinderPageModule,
        AddressPickerPageModule,
        DateTimePickerPageModule,
        ShippingAddressAddPageModule,
        CartQuotePageModule,
        QuoteEditPageModule,
        QuoteFilterPageModule,
        QuoteMarkAsSentPageModule,
        QuoteMarkAsDeclinedPageModule,
        QuoteMarkAsAcceptedPageModule,
        QuoteCancelPageModule,
        QuoteEmailPageModule], providers: [
        StorageService,
        CartService,
        DatabaseService,
        PersonService,
        ProductService,
        EventService,
        ObserverService,
        APIService,
        PusherService,
        AuthService,
        PricingTierService,
        RegisterService,
        UserService,
        PermissionService,
        OrganisationService,
        TaxZoneService,
        SupportedCurrencyService,
        ConnectedAccountService,
        PendingOrderService,
        CountryService,
        CourierService,
        DonationCampaignService,
        GiftVoucherService,
        CashTrackingService,
        ParkedCartService,
        ParkedCartLegacyService,
        QuoteService,
        OrderService,
        CustomPaymentServiceService,
        DesktopPrintClientService,
        CashDrawerService,
        ReceiptPrinterService,
        MeasurementUnitService,
        GlobalVariableService,
        StripeTerminalReaderService,
        RouterExtService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // The sell screen's images sit inside virtual-scroller lists, which already
        // avoid rendering off-screen items at all - loading="lazy" still has value for
        // items buffered just outside the viewport, so keep it rather than switching to
        // eager. This is a dev-only warning (tree-shaken from production via ngDevMode).
        { provide: IMAGE_CONFIG, useValue: { disableImageLazyLoadWarning: true } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler() },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })

export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas);
        library.addIconPacks(far);
        library.addIconPacks(fab);
        library.addIconPacks(fal);
    }
}
